"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_RENEW_HANDICAP_MS = 60 * 1000; // 1 minute
var Auth = /** @class */ (function () {
    function Auth(_a) {
        var cache = _a.cache, cacheId = _a.cacheId, _b = _a.refreshHandicapMs, refreshHandicapMs = _b === void 0 ? DEFAULT_RENEW_HANDICAP_MS : _b;
        this._cache = cache;
        this._cacheId = cacheId;
        this._refreshHandicapMs = refreshHandicapMs;
    }
    Auth.prototype.data = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._cache.getItem(this._cacheId)];
                    case 1: return [2 /*return*/, ((_a.sent()) || {
                            token_type: '',
                            access_token: '',
                            expire_time: 0,
                            expires_in: '',
                            refresh_token: '',
                            refresh_token_expires_in: '',
                            refresh_token_expire_time: 0,
                            scope: '',
                        })];
                }
            });
        });
    };
    Auth.prototype.setData = function (newData) {
        if (newData === void 0) { newData = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var data, savedData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data()];
                    case 1:
                        data = _a.sent();
                        savedData = __assign(__assign({}, data), newData);
                        if (typeof newData.expires_in !== 'undefined' && !newData.expire_time) {
                            savedData.expire_time = Date.now() + parseInt(newData.expires_in, 10) * 1000;
                        }
                        if (typeof newData.refresh_token_expires_in !== 'undefined' && !newData.refresh_token_expire_time) {
                            savedData.refresh_token_expire_time = Date.now() + parseInt(newData.refresh_token_expires_in, 10) * 1000;
                        }
                        return [4 /*yield*/, this._cache.setItem(this._cacheId, savedData)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Check if there is a valid (not expired) access token
     */
    Auth.prototype.accessTokenValid = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data()];
                    case 1:
                        authData = _a.sent();
                        if (!(authData === null || authData === void 0 ? void 0 : authData.access_token)) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, authData.expire_time - this._refreshHandicapMs > Date.now()];
                }
            });
        });
    };
    /**
     * Check if there is a valid (not expired) access token
     */
    Auth.prototype.refreshTokenValid = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data()];
                    case 1: return [2 /*return*/, (_a.sent()).refresh_token_expire_time > Date.now()];
                }
            });
        });
    };
    Auth.prototype.cancelAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.setData({
                        access_token: '',
                        expires_in: '-1',
                    })];
            });
        });
    };
    return Auth;
}());
exports.default = Auth;
//# sourceMappingURL=Auth.js.map